export function handleMouseUpByBlurring({ currentTarget }) {
  currentTarget.blur()
}



// WEBPACK FOOTER //
// ./src/utils/focus.js